import { ArrowBack } from "@mui/icons-material";
import {
  Box,
  Typography,
  Button,
} from "@mui/material";
import { useContext, useEffect, useState } from "react";
import FreeClientFormContext from "./change-plan-enrolment-context";
import { SetS3Config } from "../../awsClientConfig";
import { Storage } from "aws-amplify";
import { inRange } from "lodash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown, faPrint } from "@fortawesome/free-solid-svg-icons";
import { paths } from "../../paths";
import { useNavigate } from "react-router-dom";

const ClientServiceAgreementForm = () => {
  const { previous, next, s3key, s3Bucket } = useContext(FreeClientFormContext);
  const [agreed, setAgreed] = useState(false);
  const navigate = useNavigate();

  const [agreement, setAgreement] = useState("");

  const isPDF = s3key?.includes(".pdf");

  useEffect(() => {
    fetchAgreement();
  }, []);

  let contentType = isPDF ? "application/pdf" : "text/html";
  const fetchAgreement = async () => {
    try {
      SetS3Config(s3Bucket, "public");
      const serviceAgreement = await Storage.get(s3key, {
        customPrefix: { public: "" },
        // tagging: 'ExternalClearance=Profile',
        contentType: contentType,
      });
      if (isPDF) {
        setAgreement(serviceAgreement);
      } else {
        const html = await fetch(serviceAgreement).then((res) => res.text());
        setAgreement(html);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const download = async () => {
    try {
      SetS3Config(s3Bucket, "public");
      const Agreement: any = await Storage.get(s3key, {
        customPrefix: { public: "" },
        download: true,
        contentType: contentType,
      });
      downloadBlob(Agreement.Body, "Service Agreement");
    } catch (error) {
      console.log("error", error);
    }
  };

  function downloadBlob(blob: any, filename: any) {
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename || "download";
    const clickHandler = () => {
      setTimeout(() => {
        URL.revokeObjectURL(url);
        a.removeEventListener("click", clickHandler);
      }, 150);
    };
    a.addEventListener("click", clickHandler, false);
    a.click();
    return a;
  }

  function printPdf() {
    fetch(agreement)
      .then(async (response) => {
        return await response.arrayBuffer();
      })
      .then((result) => {
        const newBlob = new Blob([result], { type: "application/pdf" });
        const fileLink = window.URL.createObjectURL(newBlob);
        const iframe = document.createElement("iframe");
        iframe.src = fileLink;
        iframe.id = "print_pdf";
        iframe.name = "print_pdf";
        iframe.style.display = "none";
        document.body.appendChild(iframe);
        const windowVal: any = window;
        windowVal.frames["print_pdf"].focus();
        windowVal.frames["print_pdf"].print();
      })
      .catch((error) => console.log("error", error));
  }

  function printImage() {
    if (isPDF) {
      printPdf();
    } else {
      const tempHtml =
        "<html><head><scri" +
        "pt>function step1(){\n" +
        "setTimeout('step2()', 10);}\n" +
        "function step2(){window.print();window.close()}\n" +
        "</scri" +
        "pt></head><body onload='step1()'>\n" +
        "<div dangerouslySetInnerHTML={{ __html:" +
        agreement +
        " }} />" +
        "</body></html>";
      var Pagelink = "about:blank";
      var pwa: any = window.open(Pagelink, "_new");
      pwa.document.open();
      pwa.document.write(tempHtml);
      pwa.document.close();
    }
  }

  const onScrollHandler = (event: any) => {
    const target = event.target;
    const scrolledHeight = Math.trunc(target.scrollHeight - target.scrollTop);
    if (inRange(target.clientHeight, scrolledHeight - 2, scrolledHeight + 2)) {
      setAgreed(true);
    }
  };

  return (
    <Box
      sx={{
        alignItems: "flex-center",
        p: { xs: 2, md: 6, lg: 4 },
        m: { xs: 2, md: 6, lg: 4 },
      }}
    >
      <Box
        sx={{
          alignItems: "flex-center",
          pl: { xs: 2, md: 6, lg: 4 },
          pr: { xs: 2, md: 6, lg: 4 },
        }}
      >
        <Button
          variant="text"
          sx={{ color: "#212636", p: 0 }}
          onClick={previous}
        >
          {" "}
          <ArrowBack fontSize="small" /> Back
        </Button>
        <Typography variant="h5" sx={{ mt: 2 }}>
          Service Agreement
        </Typography>
      </Box>

      <Box
        sx={{
          p: 3,
          m: 2,
          mt: 2,
          border: "1px solid var(--mui-palette-divider)",
          borderRadius: 1,
        }}
      >
        <div className="text-end mt-1 mb-1">
          <span className="letsdolater" onClick={printImage}>
            <FontAwesomeIcon className="" icon={faPrint} /> Print
          </span>
          <span
            className="letsdolater"
            style={{ marginLeft: "10px" }}
            onClick={download}
          >
            <FontAwesomeIcon className="" icon={faArrowDown} /> Download
          </span>
        </div>
        <div
          className="mt-2 mb-2"
          style={{
            height: "55vh",
            overflow: "auto",
            border: "1px solid #ddd",
            borderRadius: "5px",
            padding: "20px",
          }}
          onScroll={onScrollHandler}
        >
          {isPDF ? (
            <iframe
              src={agreement}
              title="app-logo"
              style={{
                width: "100%",
                height: "95%",
                objectFit: "cover",
                border: "1px solid #ddd",
              }}
            />
          ) : (
            <div dangerouslySetInnerHTML={{ __html: agreement }} />
          )}
        </div>
        <Box className="d-flex justify-content-end">
          <Button className="me-2 text-button" onClick={() => navigate(paths.dashboard.taxShield.reports)}>Cancel</Button>
          <Button
            onClick={next}
            disabled={!agreed}
            className="option-primary-button"
          >
            Agree & Sign
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default ClientServiceAgreementForm;
